import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let TOKEN = localStorage.getItem('token');
    if(!TOKEN){
      TOKEN = ''
    }
      req = req.clone({
        setHeaders: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
      });
    // }else {
    //   alert('توکن وجود ندارد')
    // }
    return next.handle(req)
  }
}
